import { createWebSignupCheckoutSessionCache } from "../../utils/webSignupCheckoutSession";
import useWebSignupStore from "./store";

/** Membership web sign-up: the payment reference is the Stripe subscription id. */
export const webSignupCheckoutSessionCache =
  createWebSignupCheckoutSessionCache({
    getCheckoutSessionKey: () =>
      useWebSignupStore.getState().checkoutSessionKey,
    setCheckoutSessionKey: (value) =>
      useWebSignupStore.getState().setCheckoutSessionKey(value),
    getUserId: () => useWebSignupStore.getState().userId,
    setUserId: (value) => useWebSignupStore.getState().setUserId(value),
    getClientSecret: () => useWebSignupStore.getState().stripeClientSecretId,
    setClientSecret: (value) =>
      useWebSignupStore.getState().setStripeClientSecretId(value),
    getPaymentReferenceId: () => useWebSignupStore.getState().subscriptionIdToPay,
    setPaymentReferenceId: (value) =>
      useWebSignupStore.getState().setSubscriptionIdToPay(value),
  });
